import { apiGet } from './http-client';

export type PublicLegalDocuments = {
  PersonalDataProcessingText: string;
  PersonalDataProcessingVersion: number;
  PersonalDataProcessingDate: string | null;
  CrmUserAgreementText: string;
  CrmUserAgreementVersion: number;
  CrmUserAgreementDate: string | null;
  PlatformUserRulesText: string | null;
  PlatformUserRulesVersion: number | null;
  PlatformUserRulesDate: string | null;
  OrgUserAgreementText: string | null;
  OrgUserAgreementVersion: number | null;
  OrgUserAgreementDate: string | null;
};

/** GET /api/v1/public/legal-documents — тексты с подставленными плейсхолдерами (как в онбординге). */
export function fetchPublicLegalDocuments(orgSlug: string | null | undefined): Promise<PublicLegalDocuments> {
  const slug = orgSlug?.trim();
  return apiGet<PublicLegalDocuments>(
    '/api/v1/public/legal-documents',
    slug ? { org_slug: slug } : undefined
  );
}
